import React from "react";
import Header from "../components/header/Header";
import {Outlet} from "react-router-dom";
import SystemNotification from "../components/SystemNotification/SystemNotification";

const LoggedInLayout = () => {
    return <div className="logged-in-layout">
        <Header />
        <SystemNotification />
        <Outlet />
    </div>;
}

export default LoggedInLayout;